exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card { \r\n    margin-bottom: 30px;\r\n  } \r\n.card-footer {\r\npadding: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/product-card/product-card.component.css
// module id = ../../../../../src/app/product-card/product-card.component.css
// module chunks = main